import Content from '@/shared/NothingFound/Components/Content.tsx'
import Footer from '@/shared/NothingFound/Components/Footer.tsx'
import Header from '@/shared/NothingFound/Components/Header.tsx'

export default function NotFound() {
    return (
        <div className="bg-background-dark/80 absolute inset-0 z-50 flex flex-col items-center justify-center p-4 backdrop-blur-md">
            <div className="relative flex flex-col items-center justify-center">
                <Header />

                <div className="animate-in fade-in slide-in-from-bottom-4 flex max-w-md flex-col items-center space-y-4 text-center duration-500">
                    <Content />

                    <div className="flex w-full justify-center pt-4">
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    )
}
